<template>
  <div
    class="fe-z-1000 fe-flex fe-flex-col fe-gap-base fe-text-body-xxs fe-text-white fe-fixed fe-bottom-[82px] fe-left-1/2"
    style="transform: translate(-50%, 0)"
  >
    <transition-group
      name="toast"
      tag="div"
      class="fe-space-y-2"
      enter-active-class="fe-transition fe-duration-500 fe-ease-in-out"
      leave-active-class="fe-transition fe-duration-500 fe-ease-in-out"
      enter-class="fe-opacity-0"
      enter-to-class="fe-opacity-100"
      leave-class="fe-opacity-100"
      leave-to-class="fe-opacity-0"
    >
      <div
        v-for="toast in toasts"
        :key="toast.id"
        class="fe-bg-primary-grey-80 fe-rounded-pill fe-px-base fe-py-xs fe-flex fe-justify-around fe-max-w-[1184px] sm:fe-min-w-[90vw] lg:fe-min-w-[384px] fe-items-center fe-gap-s fe-shadow-l"
      >
        <div class="fe-flex" v-if="toast.type !== 'none'">
          <JdsIcon
            :name="getIconName(toast.type).name"
            size="m"
            :color="getIconName(toast.type).color"
          />
        </div>
        <div class="fe-flex-1 fe-text-primary-grey-20">
          <div class="fe-text-body-xxs-bold lg:fe-text-body-s-bold">
            {{ toast.message }}
          </div>
          <div v-if="toast.description" class="fe-text-body-xxs">
            {{ toast.description }}
          </div>
        </div>
        <div v-if="toast.ctaCallback">
          <JdsButton
            variant="secondary"
            size="small"
            @click="handleClick(toast.ctaCallback)"
            className="fe-text-white fe-text-body-xxs-bold"
          >
            Retry
          </JdsButton>
        </div>
      </div>
    </transition-group>
  </div>
</template>

<script>
  import JdsButton from "@/components/DesignSystem/JdsButton/JdsButton.vue"
  import JdsIcon from "@/components/DesignSystem/JdsIcon/JdsIcon.vue"
  import { DEFAULT_TOAST_DURATION } from "@/constants/constants"
  import { generateRandomId } from "@/utils/utils"

  export default {
    name: "ToastRegistry",
    components: {
      JdsIcon,
      JdsButton,
    },
    data() {
      return {
        toasts: [],
      }
    },
    created() {
      this.$root.$on("showToast", this.addToast)
    },
    beforeDestroy() {
      this.$root.$off("showToast", this.addToast)
    },
    methods: {
      addToast(toast) {
        // If the cancel flag is set to true, remove all existing toasts first
        if (toast.cancelPreviousToast) {
          this.toasts = []
        }

        // If the keepPreviousToastIfSame flag is set to true, Restart the timer of specified duration
        if (toast.keepPreviousToastIfSame && this.toasts.length > 0) {
          const lastToast = this.toasts[this.toasts.length - 1]

          // Reset the duration to keep the toast visible for the full time again
          lastToast.duration = toast.duration || DEFAULT_TOAST_DURATION

          // Restart the timer for the toast (re-setting it)
          clearTimeout(lastToast.timer)

          // Reset the timer to remove the toast after the specified duration
          lastToast.timer = setTimeout(() => {
            this.removeToast(lastToast)
          }, lastToast.duration)

          return // Skip adding a new toast
        }

        const toastConfig = {
          id: generateRandomId(6),
          message: toast?.message || "",
          description: toast?.description || "",
          type: toast.type || "error",
          duration: toast.duration || DEFAULT_TOAST_DURATION,
          autoClose: toast.autoClose || true,
          ctaCallback: toast.ctaCallback || null,
        }

        // Add new toast to the list
        this.toasts.push(toastConfig)

        // Set the timer to remove the toast after the specified duration
        toastConfig.timer = setTimeout(() => {
          this.removeToast(toastConfig)
        }, toastConfig.duration)
      },
      removeToast(toastConfig) {
        const index = this.toasts.findIndex(
          (toast) => toast.id === toastConfig.id,
        )

        if (index !== -1) {
          this.toasts.splice(index, 1)
        }
      },
      getIconName(type) {
        const iconNameMap = {
          error: {
            name: "ErrorIcon",
            color: "fe-text-error-50",
          },
          success: {
            name: "SuccessIcon",
            color: "fe-text-success-50",
          },
          warning: {
            name: "WarningIcon",
            color: "fe-text-warning-50",
          },
        }

        return iconNameMap[type] || {}
      },
      handleClick(ctaCallback) {
        ctaCallback && ctaCallback()
      },
    },
  }
</script>
